export enum CreditorApprovalInfoTableColumn {
  CREDITOR_NUMBER = "creditorNumber",
  CREDITOR_NAME = "name",
  CREDITOR_GROUP = "creditorGroupNo",
  REQUESTED_TYPE = "requestType",
  REQUESTED_DATE = "createdDate",
}

export const COLUMNS = [
  {
    id: 0,
    key: CreditorApprovalInfoTableColumn.CREDITOR_NUMBER,
    title: "US.COLLECTION.CREDITOR:SELECTEDCREDITOR.CREDITOR_NUMBER",
  },
  {
    id: 1,
    key: CreditorApprovalInfoTableColumn.CREDITOR_NAME,
    title: "US.COLLECTION.CREDITOR:SELECTEDCREDITOR.CREDITOR_NAME",
  },
  {
    id: 2,
    key: CreditorApprovalInfoTableColumn.CREDITOR_GROUP,
    title: "US.COLLECTION.COMMON:COMMON.CREDITOR_GROUP",
  },
  {
    id: 3,
    key: CreditorApprovalInfoTableColumn.REQUESTED_TYPE,
    title: "REQUESTED_TYPE",
  },
  {
    id: 4,
    key: CreditorApprovalInfoTableColumn.REQUESTED_DATE,
    title: "REQUESTED_DATE",
  },
];

export enum ColumnSearchType {
  STRING = "string",
  NUMBER = "number",
}

export enum Align {
  CENTER = "center",
  RIGHT = "right",
  LEFT = "left",
}

export enum DrawerTypes {
  CREDITOR_APPROVAL_ADD = "AddNewCreditorApproval",
}

export const InitialFormData = {
  requestId: -1,
  creditorGroupNo: -1,
  creditorNumber: "",
  name: " ",
  postalCode: "",
  bankAccountNumber: "",
  remitAccountNumber: "",
  orgNumber: "",
  address1: "",
  address2: "",
  country: "",
  telMobile: "",
  telWork: "",
  telHome: "",
  smsNumber: "",
  email: "",
  masterCreditorNo: "",
  vatStatus: "",
  kidRemit: false,
  otherKIDBankAccount: "",
  deductVATFromCreditor: true,
  ehF_FreeText: "",
  requestType: "",
  createdDate: "",
  contactPersons: [
    {
      firstName: "",
      lastName: "",
      address1: "",
      address2: "",
      postalCode: "",
      email: "",
      personNo: "",
      telWork: "",
      fax: "",
      role: "",
      telMobile: "",
    },
  ],
};

export enum CONTACTPERSONINFOTableColumn {
  FIRST_NAME = "firstName",
  LAST_NAME = "lastName",
  POSTAL_CODE = "postalCode",
  ADDRESS1 = "address1",
  ADDRESS2 = "address2",
  EMAIL = "email",
  PERSON_NO = "personNo",
  TEL_WORK = "telWork",
  FAX = "fax",
  TEL_MOBILE = "telMobile",
}

export const CONACTPERSONINFOCOLUMNS = [
  {
    id: 0,
    key: CONTACTPERSONINFOTableColumn.FIRST_NAME,
    title: "FIRST_NAME",
  },
  {
    id: 1,
    key: CONTACTPERSONINFOTableColumn.LAST_NAME,
    title: "US.COMMON:MANAGE_USER.LAST_NAME",
  },
  {
    id: 2,
    key: CONTACTPERSONINFOTableColumn.PERSON_NO,
    title: "US.COLLECTION.CREDITOR:CREDITOR_INFO.NIN",
  },
  {
    id: 3,
    key: CONTACTPERSONINFOTableColumn.ADDRESS1,
    title: "US.COLLECTION.DEBTOR:ADDRESSHISTORY.ADDRESS1",
  },
  {
    id: 4,
    key: CONTACTPERSONINFOTableColumn.ADDRESS2,
    title: "US.COLLECTION.DEBTOR:ADDRESSHISTORY.ADDRESS2",
  },
  {
    id: 5,
    key: CONTACTPERSONINFOTableColumn.POSTAL_CODE,
    title: "US.COMMON:COMMON.POSTAL_CODE",
  },
  {
    id: 6,
    key: CONTACTPERSONINFOTableColumn.EMAIL,
    title: "US.COLLECTION.COMMON:COMMON.EMAIL",
  },

  {
    id: 7,
    key: CONTACTPERSONINFOTableColumn.TEL_WORK,
    title: "US.COLLECTION.CREDITOR:INFO.WORK",
  },
  {
    id: 8,
    key: CONTACTPERSONINFOTableColumn.TEL_MOBILE,
    title: "US.COLLECTION.CREDITOR:INFO.MOBILE",
  },
];
